export default function Footer() {
  return <></>;
}
